/**
 * Роуты, для которых нужно показывать stories, categories и т.д
 */
export const TOP_CONTENT_VISIBLE_ROUTES = [
  'index',
  'category-category',
  'filter-category-category',
  'delivery-slug',
]
